export const buildProvenance = { "commitHash": "9252dbdc589f7d6ed8b4cb0ff9ddd2ac6e636c50", "branchName": "refs/heads/release/2023.3", "buildDate": "2023-09-22T02:43:25.272Z", "version": "2023.3.13026" };
